export default __webpack_public_path__ + "media/color/snm-321b671d.svg";